export default __webpack_public_path__ + "static/media/avatarImage.7b1342fc.png";